import { Link } from 'react-router-dom';
import StatusPill from '../../../components/ui/StatusPill/StatusPill';
import './ProjectCard.css';

function bedroomSummary(project) {
  const beds = (project.unitTypes || [])
    .map((u) => u.bedrooms)
    .filter(Boolean);
  if (!beds.length) return project.category || null;
  const min = Math.min(...beds);
  const max = Math.max(...beds);
  const range = min === max ? `${min}` : `${min}–${max}`;
  return `${range} Bedroom Residences`;
}

function specRows(project) {
  const { quickFacts = [], unitTypes = [], unitCountLabel } = project;
  const fact = (label) => quickFacts.find((f) => f.label === label)?.value;
  const rows = [];

  const units = fact('Total Units') || (unitCountLabel || '').replace(/\s*units?/i, '').trim();
  if (units) rows.push(['Units', units]);

  const beds = fact('Bedrooms');
  if (beds) rows.push(['Bedrooms', beds]);

  const hasApt = unitTypes.some((u) => /apartment/i.test(u.type));
  const hasMais = unitTypes.some((u) => /maisonette/i.test(u.type));
  const resType = [hasApt && 'Apartments', hasMais && 'Maisonettes'].filter(Boolean).join(' & ');
  if (resType) rows.push(['Residences', resType]);

  return rows;
}

export default function ProjectCard({ project, featured = false }) {
  const {
    slug,
    name,
    location,
    status,
    shortDescription,
    cardImage,
    category,
    keyFeatures = [],
    imageMode,
  } = project;
  const beds = bedroomSummary(project);
  const spec = featured ? specRows(project) : [];
  const isFlyer = imageMode === 'flyer';

  return (
    <Link
      to={`/projects/${slug}`}
      className={`project-card${featured ? ' project-card--featured' : ''}`}
    >
      <div className={`project-card__img${isFlyer ? ' project-card__img--flyer' : ''}`}>
        <img
          src={cardImage?.src}
          alt={cardImage?.alt || name}
          width={cardImage?.width}
          height={cardImage?.height}
          loading={featured ? 'eager' : 'lazy'}
        />
        <span className="project-card__status">
          <StatusPill status={status} size="sm" onDark />
        </span>
      </div>

      <div className="project-card__body">
        {category && <p className="project-card__cat">{category}</p>}
        <h3 className="project-card__title">{name}</h3>
        <p className="project-card__loc">{location.display}</p>
        {beds && <p className="project-card__beds">{beds}</p>}
        {shortDescription && (
          <p className="project-card__desc">{shortDescription}</p>
        )}

        {spec.length > 0 && (
          <div className="project-card__spec">
            {spec.map(([k, v]) => (
              <div key={k} className="project-card__spec-row">
                <span className="project-card__spec-k">{k}</span>
                <span className="project-card__spec-v">{v}</span>
              </div>
            ))}
          </div>
        )}

        {featured && keyFeatures.length > 0 && (
          <p className="project-card__features">{keyFeatures.join(' · ')}</p>
        )}

        <span className="project-card__cta">
          View Project
          <span aria-hidden="true">→</span>
        </span>
      </div>
    </Link>
  );
}
